import * as userUtil from "./userUtil";
import * as Aes256 from "./aes256";

const ACCESS_TOKEN = "BIZCHAT_ACCESS_TOKEN";
const REFRESH_TOKEN = "BIZCHAT_REFRESH_TOKEN";
const USER = "BIZCHAT_AUTH_USER";

const AES_KEY_FOR_USER_INFO = process.env.REACT_APP_AES_KEY_FOR_USER_INFO;

export function getGradeFromRoles() {
    const roles = getRoles();

    if (! roles || roles.includes(userUtil.ROLE_RETIRE)) {
        return userUtil.GRADE_RETIRE;
    } else if (roles.includes(userUtil.ROLE_USER)) {
        return userUtil.GRADE_USER;
    } else if (roles.includes(userUtil.ROLE_SUB_ADMIN)) {
        return userUtil.GRADE_SUB_ADMIN;
    } else if (roles.includes(userUtil.ROLE_ADMIN)) {
        return userUtil.GRADE_ADMIN;
    }
}

export function getAccessToken() {
    const localToken = window.localStorage.getItem(ACCESS_TOKEN)
    return localToken == null ? window.sessionStorage.getItem(ACCESS_TOKEN) : localToken;
}

export function getRefreshToken() {
    const localToken = window.localStorage.getItem(REFRESH_TOKEN)
    return localToken == null ? window.sessionStorage.getItem(REFRESH_TOKEN) : localToken;
}

export function setReissuedToken(accessToken, refreshToken) {
    if(window.localStorage.getItem(ACCESS_TOKEN) == null) {
        /* To sessionStorage */
        setAccessTokenToSessionStorage(accessToken);
        setRefreshTokenToSessionStorage(refreshToken);
    } else {
        /* To localStorage */
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
    }
}

export function setAccessToken(accessToken) {
    window.localStorage.setItem(ACCESS_TOKEN, accessToken);
}

export function setRefreshToken(refreshToken) {
    window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
}

export function setAccessTokenToSessionStorage(accessToken) {
    /* 로그인 정보 저장 체크 X시 동작. 세션 스토리지는 브라우저 종료시 스토리지 Clear */
    window.sessionStorage.setItem(ACCESS_TOKEN, accessToken);
}

export function setRefreshTokenToSessionStorage(refreshToken) {
    /* 로그인 정보 저장 체크 X시 동작. 세션 스토리지는 브라우저 종료시 스토리지 Clear */
    window.sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
}

export function getUser() {
    try {
        const user = JSON.parse(Aes256.aesDecrypt(window.localStorage.getItem(USER), AES_KEY_FOR_USER_INFO));
        // delete user.roles;
        return user;
    } catch (error) {
        return null;
    }
}

export function getRoles() {
    try {
        const user = JSON.parse(Aes256.aesDecrypt(window.localStorage.getItem(USER), AES_KEY_FOR_USER_INFO));
        return user.roles;
    } catch (error) {
        return null;
    }
}

export function setUserInfo(userInfo) {
    window.localStorage.removeItem(USER);
    window.localStorage.setItem(USER, userInfo);
}

export function clearToken() {
    window.localStorage.removeItem(ACCESS_TOKEN);
    window.localStorage.removeItem(REFRESH_TOKEN);
    window.sessionStorage.removeItem(ACCESS_TOKEN);
    window.sessionStorage.removeItem(REFRESH_TOKEN);
}

/** 탈퇴·완전 로그아웃 시 인증 토큰과 암호화된 사용자 정보를 함께 제거합니다. */
export function clearAuthStorage() {
    clearToken();
    window.localStorage.removeItem(USER);
}
